import { Component, computed, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslatePipe } from '@app/common-codes/components/directives/TranslatePipe';
import { MatwinsVariablesService } from '@app/common-codes/services/matwinsVariables.service';
import { NavigationService } from '@app/common-codes/services/navigation.service';
import { CurrentTenantService } from '@app/common-codes/services/CurrentTenantService';
import { VISITOR_TYPES, VisitorTypeDefinition, visibleVisitorTypes as visibleTypesForChannel } from '../../shared/visitor-types';

@Component({
    selector: 'app-qrcode-visitor-type',
    imports: [TranslatePipe],
    templateUrl: './qrcode-visitor-type.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styles: ``
})
export class QrcodeVisitorTypeComponent {

    visitorTypes = VISITOR_TYPES;

    /** Types affichés selon les options QR Code activées dans l'admin (PointOfService). */
    visibleVisitorTypes = computed(() => {
        const visible = visibleTypesForChannel('qr', this.tenantService.currentPointOfService());

        if (!this.isCheckoutMode) return visible;

        // En mode checkout, visiteur/entrepreneur/employé partagent la même page
        // (recherche par nom dans toutes les visites actives) : bouton fusionné.
        const merged: VisitorTypeDefinition[] = [];
        const visitor = VISITOR_TYPES.find(type => type.key === 'visitor');
        if (visitor && visible.some(type => type.key !== 'trucker')) {
            merged.push(visitor);
        }
        const trucker = visible.find(type => type.key === 'trucker');
        if (trucker) merged.push(trucker);
        return merged;
    });

    /** Mode 'checkout' quand la page est utilisée comme choix de type pour la sortie. */
    isCheckoutMode = false;

    constructor(
        private navService: NavigationService,
        private variables: MatwinsVariablesService,
        private tenantService: CurrentTenantService,
        route: ActivatedRoute
    ) {
        this.isCheckoutMode = route.snapshot.data['mode'] === 'checkout';
    }

    selectVisitorType(typeKey: string) {
        const base = `/qrcode/${this.variables.clientId}/${this.variables.posId}`;
        let route: string;
        if (this.isCheckoutMode) {
            route = typeKey === 'trucker'
                ? `${base}/trucker-checkout`
                : `${base}/checkout`;
        } else {
            route = typeKey === 'trucker'
                ? `${base}/trucker-checkin`
                : `${base}/checkin/${typeKey}`;
        }
        this.navService.navigateTo(route);
    }
}
